// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"79820da7","455":"3f067ee1","946":"8229455e"}[chunkId] + ".chunk.js";
};